import React, { useEffect } from "react";
import { Dialog, Button, Text, Box } from "@primer/react";
import { DownloadIcon } from "@primer/octicons-react";

export interface DownloadConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  exportType: string;
  autoCloseMs?: number;
}

export const DownloadConfirmationDialog: React.FC<DownloadConfirmationDialogProps> = ({
  isOpen,
  onClose,
  exportType,
  autoCloseMs = 4000,
}) => {
  useEffect(() => {
    if (isOpen && autoCloseMs > 0) {
      const timer = setTimeout(onClose, autoCloseMs);
      return () => clearTimeout(timer);
    }
  }, [isOpen, autoCloseMs, onClose]);

  if (!isOpen) return null;

  return (
    <Dialog title="Download Started" onClose={onClose}>
      <Dialog.Body>
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 3 }}>
          <Box sx={{ flexShrink: 0, color: "accent.fg" }}>
            <DownloadIcon size={48} />
          </Box>
          <Text>
            Your {exportType.toUpperCase()} export has been started and will be
            processed in the background. You can track its progress and download it
            when ready using the download tray icon in the header.
          </Text>
        </Box>
      </Dialog.Body>
      <Dialog.Footer>
        <Button onClick={onClose}>
          Close
        </Button>
      </Dialog.Footer>
    </Dialog>
  );
};

export default DownloadConfirmationDialog;

